export default __webpack_public_path__ + "static/countries-48595bf60fdfc71f3f0a95cdd5b8b5dc.png";